import angular from 'angular';


import DocumentFactory from './documentFactory';
import TimestampFactory from './timestampFactory';
import DropzoneFactory from './dropzoneFactory';
import MapboxFactory from './mapBoxFactory';

export default angular.module('app.common.angular.globalFactories', [])
    .factory('document', DocumentFactory)
    .factory('Timestamp', TimestampFactory)
    .factory('DropzoneFactory', DropzoneFactory)
    .factory('mapBoxGL', MapboxFactory)
    .name;



// WEBPACK FOOTER //
// ./src/app/common/angular/globalFactories/index.js